import { 
  LayoutGrid, 
  User, 
  Globe, 
  Star, 
  Settings, 
  MessagesSquare, 
  CalendarDays,
  CalendarCheck,
  Gift,
  Users,
  Link2,
  UserPlus,
  MapPin,
  TrendingUp,
  Radio,
  ClipboardList,
} from 'lucide-react';
import type { ReactNode } from 'react';
import logoWhite from '@/assets/images/logo_no_bg_white.png';

// Custom SVG icons as components
export const ArtistsIcon = ({ className, style }: { className?: string; style?: React.CSSProperties }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1600 1600" fill="currentColor" className={className} style={style}>
    <path d="M 478.251 52.2864 C 495.404 50.7323 511.581 53.9471 525.786 64.1622 C 543.498 76.8988 558.338 104.164 561.385 125.716 C 575.185 123.815 592.605 117.463 606.419 113.581 C 675.884 94.0542 746.239 80.7027 818.694 83.87 C 833.427 84.514 848.731 83.1038 863.512 84.4081 C 946.434 91.212 1037.28 137.869 1032.12 234.093 C 1031.86 244.994 1033.1 256.403 1031.33 267.197 C 1020.69 331.871 986.175 388.28 951.562 442.657 C 946.022 451.359 940.492 460.051 933.755 467.772 C 927.739 474.667 921.941 478.172 913.737 481.263 C 921.182 552.741 912.889 616.082 877.729 679.67 C 836.239 754.427 766.576 809.487 684.257 832.587 C 625.516 851.415 543.915 844.869 486.483 823.016 C 411.355 793.851 349.926 737.526 314.369 665.204 C 309.785 655.777 304.962 644.702 301.419 634.862 C 298.563 626.929 297.525 618.821 293.955 610.887 C 287.895 606.381 258.048 608.713 248.28 607.6 C 239.231 606.568 230.133 604.404 221.475 601.607 C 199.969 594.66 171.954 572.676 161.577 552.099 C 152.707 534.51 154.071 475.475 160.496 456.568 C 173.266 418.991 198.351 386.023 224.218 356.486 C 295.324 276.405 381.194 210.777 477.133 163.19 C 459.33 144.012 431.061 122.927 420.304 98.5988 C 419.509 96.7987 419.922 89.547 420.039 87.1542 C 435.754 64.6653 453.148 59.316 478.251 52.2864 z M 372.244 502.68 C 417.881 491.592 471.141 482.005 517.812 472.414 L 724.745 428.481 L 807.188 411.077 C 822.506 407.872 844.077 404.068 858.479 399.116 C 881.409 363.871 943.4 270.568 934.777 229.19 C 932.232 216.979 924.228 208.264 913.996 201.616 C 884.711 182.586 836.692 175.161 802.188 176.428 C 779.188 177.463 750.592 182.436 726.486 186.804 C 568.002 215.519 417.324 296.798 307.36 414.651 C 297.402 425.323 238.402 495.588 256.786 507.014 C 286.949 525.763 338.31 509.2 372.244 502.68 z M 396.363 597.358 C 406.528 629.889 429.725 665.516 455.615 687.762 C 499.957 725.685 556.087 747.14 614.801 742.569 C 672.167 738.082 725.47 711.223 763.212 667.789 C 798.598 626.335 820.562 568.4 816.435 513.742 C 816.352 512.637 816.245 511.534 816.115 510.434 C 815.415 509.882 815.106 509.401 814.509 509.412 C 807.922 512.943 746.152 523.268 733.16 526.066 L 513.784 573.573 L 441.506 589.181 C 427.486 592.152 410.268 596.482 396.363 597.358 z"/>
    <path d="M 381.295 1010.43 C 410.202 1009.5 442.071 1010.13 471.141 1010.14 L 631.372 1010.13 L 751.52 1010.11 C 773.795 1010.11 799.126 1009.39 821.03 1010.72 C 908.105 1016.01 982.836 1054.57 1040.15 1119.9 C 1083.76 1169.61 1110.11 1232.09 1115.26 1298.01 C 1117.24 1322.82 1116.01 1350.7 1116.19 1375.97 C 1116.4 1404.99 1116.6 1434.93 1116.14 1463.9 C 1115.29 1478.66 1109.1 1489.49 1098.33 1499.05 C 1073.14 1521.43 1028.68 1508.89 1019.08 1476.97 C 1015.47 1464.94 1016.69 1435.26 1016.85 1421.69 C 1017.87 1337.45 1024.87 1255.53 965.187 1187.24 C 929.459 1144.12 874.462 1116.3 819.066 1111.29 C 785.749 1109.78 749.959 1110.39 716.37 1110.39 L 553.742 1110.43 L 447.669 1110.36 C 424.924 1110.35 396.523 1109.7 374.246 1112.27 C 335.058 1116.97 297.88 1132.22 266.677 1156.39 C 222.577 1190.24 193.872 1241.69 185.679 1296.54 C 182.362 1318.75 182.942 1341.46 182.946 1363.88 C 182.86 1388.56 182.906 1413.25 183.085 1437.93 C 183.162 1455.05 185.127 1476.33 173.603 1490.38 C 164.548 1501.42 152.748 1508.48 138.515 1510.07 C 111.562 1513.08 85.0696 1493.46 84.0148 1465.6 C 82.9454 1437.35 84.1907 1409.01 83.8158 1380.74 C 83.994 1353.85 82.6747 1325.21 84.7223 1298.38 C 89.6094 1234.34 114.436 1173.43 155.715 1124.22 C 216.498 1052.19 288.372 1018.27 381.295 1010.43 z"/>
    <path d="M 1184.1 84.315 C 1239.19 81.1696 1305.26 81.1345 1357.52 98.482 C 1458.54 132.019 1479.49 221.297 1447.09 314.718 C 1441.02 331.843 1433.85 348.557 1425.62 364.756 C 1414.63 386.588 1373.3 459.606 1356.2 473.239 C 1344.75 482.37 1328.21 485.677 1315.07 492.057 C 1315.05 506.522 1316.29 520.659 1315.92 535.455 C 1315.08 584.441 1302.6 632.525 1279.52 675.741 C 1239.26 750.418 1171.14 806.179 1089.99 830.895 C 1060.8 839.701 1030.82 834.545 1018.68 800.714 C 1012.47 783.421 1019.03 758.648 1032.98 747.103 C 1040.58 740.814 1045.31 738.397 1055.25 735.476 C 1158 704.337 1215.97 622.984 1216.33 516.33 C 1192.98 516.903 1148.11 530.355 1123.35 534.541 C 1112.88 536.31 1103.32 539.678 1091.94 539.931 C 1084.58 540.155 1077.26 538.693 1070.55 535.656 C 1034.9 519.91 1033.95 473.188 1063.22 448.883 C 1067.31 445.485 1103.2 438.873 1111.25 437.183 L 1225.95 412.989 C 1241.96 409.595 1271.9 404.293 1286.48 399.115 C 1306.72 368.215 1328.61 334.668 1343.68 301.501 C 1352.24 282.667 1368.43 246.805 1362.34 227.247 C 1349.83 187.056 1276.65 177.991 1240.7 176.109 C 1216.71 174.853 1196.81 186.663 1175.06 174.624 C 1135.16 153.711 1139.51 96.0801 1184.1 84.315 z"/>
    <path d="M 1258.56 1019.4 C 1289.32 1017.8 1329.78 1035.88 1356.34 1050.98 C 1428.98 1092.34 1482.44 1160.63 1505.14 1241.08 C 1510.21 1259.78 1513.56 1278.9 1515.15 1298.22 C 1517.71 1328.64 1515.61 1364.33 1516.2 1395.34 C 1515.56 1418.85 1517.65 1443.16 1515.9 1466.57 C 1514.12 1490.19 1495.88 1504.67 1474.84 1510.01 C 1460.17 1510.84 1449.78 1509.77 1437.4 1501.27 C 1411.37 1483.37 1416.92 1455.5 1417.01 1427.89 L 1416.98 1365.98 C 1417 1340.37 1417.63 1317.01 1413.23 1291.67 C 1401.56 1221.79 1356.42 1162.05 1292.38 1131.76 C 1276.43 1124.31 1249.43 1118.23 1237.06 1109.66 C 1202.03 1085.38 1213.4 1025.55 1258.56 1019.4 z"/>
  </svg>
);

export const MatcherIcon = ({ className, style }: { className?: string; style?: React.CSSProperties }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className={className} style={style}>
    <path fillRule="evenodd" d="M12.963 2.286a.75.75 0 0 0-1.071-.136 9.742 9.742 0 0 0-3.539 6.177A7.547 7.547 0 0 1 6.648 6.61a.75.75 0 0 0-1.152-.082A9 9 0 1 0 15.68 4.534a7.46 7.46 0 0 1-2.717-2.248ZM15.75 14.25a3.75 3.75 0 1 1-7.313-1.172c.628.465 1.35.81 2.133 1a5.99 5.99 0 0 1 1.925-3.546 3.75 3.75 0 0 1 3.255 3.718Z" clipRule="evenodd" />
  </svg>
);

export const FotwStarIcon = ({ className, style }: { className?: string; style?: React.CSSProperties }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className={className} style={style}>
    <path fillRule="evenodd" d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z" clipRule="evenodd" />
  </svg>
);

export const ChatsIcon = ({ className, style }: { className?: string; style?: React.CSSProperties }) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className={className} style={style}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M20.25 8.511c.884.284 1.5 1.128 1.5 2.097v4.286c0 1.136-.847 2.1-1.98 2.193-.34.027-.68.052-1.02.072v3.091l-3-3c-1.354 0-2.694-.055-4.02-.163a2.115 2.115 0 0 1-.825-.242m9.345-8.334a2.126 2.126 0 0 0-.476-.095 48.64 48.64 0 0 0-8.048 0c-1.131.094-1.976 1.057-1.976 2.192v4.286c0 .837.46 1.58 1.155 1.951m9.345-8.334V6.637c0-1.621-1.152-3.026-2.76-3.235A48.455 48.455 0 0 0 11.25 3c-2.115 0-4.198.137-6.24.402-1.608.209-2.76 1.614-2.76 3.235v6.226c0 1.621 1.152 3.026 2.76 3.235.577.075 1.157.14 1.74.194V21l4.155-4.155" />
  </svg>
);

export const BookingsCalendarIcon = ({ className, style }: { className?: string; style?: React.CSSProperties }) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className={className} style={style}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 2.994v2.25m10.5-2.25v2.25m-14.252 13.5V7.491a2.25 2.25 0 0 1 2.25-2.25h13.5a2.25 2.25 0 0 1 2.25 2.25v11.251m-18 0a2.25 2.25 0 0 0 2.25 2.25h13.5a2.25 2.25 0 0 0 2.25-2.25m-18 0v-7.5a2.25 2.25 0 0 1 2.25-2.25h13.5a2.25 2.25 0 0 1 2.25 2.25v7.5m-6.75-6h2.25m-9 2.25h4.5m.002-2.25h.005v.006H12v-.006Zm-.001 4.5h.006v.006h-.006v-.005Zm-2.25.001h.005v.006H9.75v-.006Zm-2.25 0h.005v.005h-.006v-.005Zm6.75-2.247h.005v.005h-.005v-.005Zm0 2.247h.006v.006h-.006v-.006Zm2.25-2.248h.006V15H16.5v-.005Z" />
  </svg>
);

export const CalendarOutlineIcon = ({ className, style }: { className?: string; style?: React.CSSProperties }) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className={className} style={style}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" />
  </svg>
);

export const DashboardIcon = ({ className, style }: { className?: string; style?: React.CSSProperties }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className={className} style={style}>
    <path fillRule="evenodd" d="M3 6a3 3 0 013-3h2.25a3 3 0 013 3v2.25a3 3 0 01-3 3H6a3 3 0 01-3-3V6zm9.75 0a3 3 0 013-3H18a3 3 0 013 3v2.25a3 3 0 01-3 3h-2.25a3 3 0 01-3-3V6zM3 15.75a3 3 0 013-3h2.25a3 3 0 013 3V18a3 3 0 01-3 3H6a3 3 0 01-3-3v-2.25zm9.75 0a3 3 0 013-3H18a3 3 0 013 3V18a3 3 0 01-3 3h-2.25a3 3 0 01-3-3v-2.25z" clipRule="evenodd" />
  </svg>
);

export const AvailabilityIcon = ({ className, style }: { className?: string; style?: React.CSSProperties }) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className={className} style={style}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
  </svg>
);

// Badge state interface
export interface BadgeState {
  hasUnreadChats?: boolean;
  unreadCount?: number;
  needsNotificationSetup?: boolean;
  isNative?: boolean;
  currentPath?: string;
}

// Navigation item definition
export interface NavItem {
  readonly id: string;
  readonly labelKey: string;
  readonly path: string | ((artistId?: string) => string); // Can be string or function for dynamic paths
  readonly pathMatches: string[]; // Paths to match for active state
  readonly icon: (props: { className?: string; style?: React.CSSProperties }) => ReactNode;
  // Badge configuration - function that returns badge info based on state
  readonly getBadge?: (state: BadgeState) => { show: boolean; count?: number; dot?: boolean } | null;
  readonly requiresAuth?: boolean;
}

// All navigation items - single source of truth
export const NAV_ITEMS = {
  // ============ BOTTOM NAV ITEMS ============
  DISCOVER: {
    id: 'discover',
    labelKey: 'navigation.discover',
    path: '/discover',
    pathMatches: ['/discover'],
    icon: ({ className, style }) => <LayoutGrid className={className} style={style} />,
  },

  BOARD: {
    id: 'board',
    labelKey: 'navigation.board',
    path: '/board',
    pathMatches: ['/board'],
    icon: ({ className, style }) => <Radio className={className} style={style} />,
  },

  FEED: {
    id: 'feed',
    labelKey: 'navigation.feed',
    path: '/discover',
    pathMatches: ['/discover', '/feed'],
    icon: ({ className, style }) => <LayoutGrid className={className} style={style} />,
  },
  
  ARTISTS: {
    id: 'artists',
    labelKey: 'navigation.artists',
    path: '/discover?type=artists',
    pathMatches: ['/discover', '/artists'],
    icon: ({ className, style }) => <ArtistsIcon className={className} style={style} />,
  },
  
  FOTW: {
    id: 'fotw',
    labelKey: 'navigation.fotw',
    path: '/fotw',
    pathMatches: ['/fotw'],
    icon: ({ className, style }) => <FotwStarIcon className={className} style={style} />,
  },
  
  GIFT_CARD: {
    id: 'giftCard',
    labelKey: 'menu.buyGiftCard',
    path: '/giftcard',
    pathMatches: ['/giftcard'],
    icon: ({ className, style }) => <Gift className={className} style={style} />,
  },
  
  CHATS: {
    id: 'chats',
    labelKey: 'navigation.chats',
    path: '/chats',
    pathMatches: ['/chats'],
    icon: ({ className, style }) => <ChatsIcon className={className} style={style} />,
    getBadge: (state) => state.unreadCount && state.unreadCount > 0 && state.isNative 
      ? { show: true, count: state.unreadCount } 
      : null,
  },
  
  WAITLIST: {
    id: 'waitlist',
    labelKey: 'navigation.waitlist',
    path: '/guest-artists/waitlist',
    pathMatches: ['/guest-artists/waitlist'],
    icon: ({ className, style }) => <Globe className={className} style={style} />,
  },
  
  // Artist profile - dynamic path based on artistId
  ARTIST_PROFILE: {
    id: 'artistProfile',
    labelKey: 'navigation.profile',
    path: (artistId?: string) => `/artist/${artistId}`,
    pathMatches: [], // Will be computed dynamically
    icon: ({ className, style }) => <User className={className} style={style} />,
  },
  
  BOOKINGS_DASHBOARD: {
    id: 'bookingsDashboard',
    labelKey: 'navigation.dashboard',
    path: '/booking-system/dashboard',
    pathMatches: ['/booking-system/dashboard', '/booking-system/'],
    icon: ({ className, style }) => <BookingsCalendarIcon className={className} style={style} />,
    getBadge: (state) => state.unreadCount && state.unreadCount > 0 && state.isNative 
      ? { show: true, count: state.unreadCount } 
      : null,
  },
  
  // Booking system dashboard specific items
  CALENDAR: {
    id: 'calendar',
    labelKey: 'navigation.calendar',
    path: '/booking-system/calendar',
    pathMatches: ['/booking-system/calendar'],
    icon: ({ className, style }) => <CalendarOutlineIcon className={className} style={style} />,
  },
  
  DASHBOARD: {
    id: 'dashboard',
    labelKey: 'navigation.dashboard',
    path: '/booking-system/dashboard',
    pathMatches: ['/booking-system/dashboard'],
    icon: ({ className, style }) => <DashboardIcon className={className} style={style} />,
    getBadge: (state) => state.unreadCount && state.unreadCount > 0 && state.isNative 
      ? { show: true, count: state.unreadCount } 
      : null,
  },
  
  AVAILABILITY: {
    id: 'availability',
    labelKey: 'navigation.availability',
    path: '/booking-system/availability',
    pathMatches: ['/booking-system/availability'],
    icon: ({ className, style }) => <AvailabilityIcon className={className} style={style} />,
  },
  
  // ============ MENU ITEMS ============
  PROFILE: {
    id: 'profile',
    labelKey: 'navigation.profile',
    path: '/profile',
    pathMatches: ['/profile'],
    icon: ({ className, style }) => <User className={className} style={style} />,
    getBadge: (state) => state.unreadCount && state.unreadCount > 0 && state.isNative 
      ? { show: true, count: state.unreadCount } 
      : null,
  },
  
  SETTINGS: {
    id: 'settings',
    labelKey: 'settings.title',
    path: '/settings',
    pathMatches: ['/settings'],
    icon: ({ className, style }) => <Settings className={className} style={style} />,
    getBadge: (state) => {
      // Don't show badge if user is on the settings page
      if (state.currentPath === '/settings') {
        return null;
      }
      return state.needsNotificationSetup ? { show: true, dot: true } : null;
    },
  },
  
  LIVE_CHAT: {
    id: 'liveChat',
    labelKey: 'menu.liveChat',
    path: '/live-chat',
    pathMatches: ['/live-chat'],
    icon: ({ className, style }) => <MessagesSquare className={className} style={style} />,
  },
  
  EVENTS: {
    id: 'events',
    labelKey: 'navigation.events',
    path: '/events',
    pathMatches: ['/events'],
    icon: ({ className, style }) => <CalendarDays className={className} style={style} />,
  },
  
  MATCHER: {
    id: 'matcher',
    labelKey: 'navigation.match',
    path: '/tattoo-artist-matcher',
    pathMatches: ['/tattoo-artist-matcher'],
    icon: ({ className, style }) => <MatcherIcon className={className} style={style} />,
  },
  
  RATE_MY_ARTIST: {
    id: 'rateMyArtist',
    labelKey: 'navigation.rateMyArtist',
    path: '/rate-my-artist',
    pathMatches: ['/rate-my-artist'],
    icon: ({ className, style }) => <Star className={className} style={style} />,
  },
  
  GUESTS: {
    id: 'guests',
    labelKey: 'navigation.guests',
    path: '/guest-artists',
    pathMatches: ['/guest-artists'],
    icon: ({ className, style }) => <Globe className={className} style={style} />,
  },
  
  // Artist menu specific
  FOTW_MENU: {
    id: 'fotwMenu',
    labelKey: 'navigation.fotw',
    path: '/fotw',
    pathMatches: ['/fotw'],
    icon: ({ className, style }) => <FotwStarIcon className={className} style={style} />,
  },
  
  BOOKINGS_DEMO: {
    id: 'bookingsDemo',
    labelKey: 'menu.bookingsDemo',
    path: '/booking-system/dashboard',
    pathMatches: ['/booking-system/'],
    icon: ({ className, style }) => <CalendarCheck className={className} style={style} />,
  },

  FOR_ARTISTS: {
    id: 'forArtists',
    labelKey: 'menu.forArtists',
    path: '/for-artists',
    pathMatches: ['/for-artists'],
    icon: ({ className, style }) => <ArtistsIcon className={className} style={style} />,
  },

  CITY_REQUESTS: {
    id: 'cityRequests',
    labelKey: 'menu.cityRequests',
    path: '/city-requests',
    pathMatches: ['/city-requests'],
    icon: ({ className, style }) => <MapPin className={className} style={style} />,
  },

  BOOKING_SETTINGS: {
    id: 'bookingSettings',
    labelKey: 'menu.bookingSettings',
    path: '/booking-system/settings',
    pathMatches: ['/booking-system/settings'],
    icon: ({ className, style }) => <Settings className={className} style={style} />,
  },

  CLIENTS: {
    id: 'clients',
    labelKey: 'menu.clients',
    path: '/booking-system/clients',
    pathMatches: ['/booking-system/clients'],
    icon: ({ className, style }) => <Users className={className} style={style} />,
  },

  GET_MORE_TATS: {
    id: 'getMoreTats',
    labelKey: 'menu.getMoreTats',
    path: '/discover',
    pathMatches: ['/discover', '/feed'],
    icon: ({ className, style }) => (
      <img 
        src={logoWhite} 
        alt="GetMoreTats" 
        className={className}
        style={{...style, objectFit: 'contain', transform: 'scale(1.15)'}}
      />
    ),
  },

  SHARE_BOOKING_LINK: {
    id: 'shareBookingLink',
    labelKey: 'menu.shareBookingLink',
    path: '#', // This item doesn't navigate, it opens a modal
    pathMatches: [],
    icon: ({ className, style }) => <Link2 className={className} style={style} />,
  },

  INVITE_ARTIST: {
    id: 'inviteArtist',
    labelKey: 'menu.inviteArtist',
    path: '#',
    pathMatches: [],
    icon: ({ className, style }) => <UserPlus className={className} style={style} />,
  },

  ANALYTICS: {
    id: 'analytics',
    labelKey: 'menu.analytics',
    path: '/analytics',
    pathMatches: ['/analytics'],
    icon: ({ className, style }) => <TrendingUp className={className} style={style} />,
  },

  BOARD_POST_DRAFTS: {
    id: 'boardPostDrafts',
    labelKey: 'menu.boardPostDrafts',
    path: '/board-post-drafts',
    pathMatches: ['/board-post-drafts'],
    icon: ({ className, style }) => <ClipboardList className={className} style={style} />,
  },
} as const satisfies Record<string, NavItem>;

// ---------------------------------------------------------------------------
// Shared nav layouts (use in TopNav + bottom nav + slide-down menus)
// ---------------------------------------------------------------------------

/** Excluded from slide-down "More" menus (routes can stay reachable via URL). */
const HIDDEN_MORE_MENU_ITEM_IDS = new Set<string>(['guests']);

export function omitHiddenMoreMenuItems(items: readonly NavItem[]): NavItem[] {
  return items.filter((item) => !HIDDEN_MORE_MENU_ITEM_IDS.has(item.id));
}

export function getMoreMenuItemsForUser(params: {
  isArtist: boolean;
  isAdmin: boolean;
}): NavItem[] {
  const baseItems = omitHiddenMoreMenuItems(
    params.isArtist ? ARTISTS_MORE_MENU_ITEMS : USERS_MORE_MENU_ITEMS,
  );

  if (!params.isAdmin) {
    return baseItems;
  }

  return [NAV_ITEMS.BOARD_POST_DRAFTS, NAV_ITEMS.ANALYTICS, ...baseItems];
}

export function getMoreMenuPaths(items: readonly NavItem[]): string[] {
  return items.flatMap((item) => item.pathMatches);
}

/** Main bar — regular users (bottom nav + desktop TopNav) */
export const USERS_MAIN_NAV_ITEMS: readonly NavItem[] = [
  NAV_ITEMS.BOARD,
  NAV_ITEMS.GUESTS,
  NAV_ITEMS.DISCOVER,
  NAV_ITEMS.PROFILE,
];

/** "More" — regular users (no gift card) */
export const USERS_MORE_MENU_ITEMS: readonly NavItem[] = [
  NAV_ITEMS.CITY_REQUESTS,
  NAV_ITEMS.MATCHER,
  NAV_ITEMS.LIVE_CHAT,
  NAV_ITEMS.SETTINGS,
];

export const USERS_MORE_MENU_PATHS = omitHiddenMoreMenuItems(USERS_MORE_MENU_ITEMS).flatMap(
  (i) => i.pathMatches,
);

/** "More" — artists: matcher, invite artist, city requests, settings + live chat (same mobile Sheet + desktop TopNav) */
export const ARTISTS_MORE_MENU_ITEMS: readonly NavItem[] = [
  NAV_ITEMS.MATCHER,
  NAV_ITEMS.INVITE_ARTIST,
  NAV_ITEMS.CITY_REQUESTS,
  NAV_ITEMS.SETTINGS,
  NAV_ITEMS.LIVE_CHAT,
];

export const ARTISTS_MORE_MENU_PATHS = omitHiddenMoreMenuItems(ARTISTS_MORE_MENU_ITEMS).flatMap(
  (i) => i.pathMatches,
);

/** Main bar for artists: trial / no booking vs paid booking (see BottomNavWrapper) */
export function getArtistMainNavItems(params: { hasBookingSystem: boolean; isTrial: boolean }): readonly NavItem[] {
  if (params.hasBookingSystem && !params.isTrial) {
    return [NAV_ITEMS.BOARD, NAV_ITEMS.DISCOVER, NAV_ITEMS.BOOKINGS_DASHBOARD, NAV_ITEMS.ARTIST_PROFILE];
  }
  return [NAV_ITEMS.BOARD, NAV_ITEMS.DISCOVER, NAV_ITEMS.CHATS, NAV_ITEMS.ARTIST_PROFILE];
}

/** Main app-shell bottom nav for subscribed artists — Discover, Bookings dashboard, Profile (see BookingSystemBottomNav). */
export function getBookingSystemMainNavItems(): readonly NavItem[] {
  return [NAV_ITEMS.BOARD, NAV_ITEMS.DISCOVER, NAV_ITEMS.BOOKINGS_DASHBOARD, NAV_ITEMS.ARTIST_PROFILE];
}

/** Active state for a main-nav item (mirrors BottomNavButton rules) */
export function isMainNavItemActive(
  item: NavItem,
  pathname: string,
  artistId?: string | null
): boolean {
  if (item.id === 'artistProfile' && artistId) {
    return pathname === `/artist/${artistId}` || pathname === `/${artistId}`;
  }
  if (item.id === 'artists' || item.id === 'discover') {
    return (
      isPathActive(pathname, item.pathMatches) ||
      (pathname.startsWith('/artist/') && pathname !== `/artist/${artistId}`)
    );
  }
  if (item.id === 'board') {
    return isPathActive(pathname, item.pathMatches);
  }
  if (item.pathMatches.length === 0) {
    return false;
  }
  return item.pathMatches.some((match) => pathname === match || pathname.startsWith(`${match}/`));
}

// Helper to check if a path is active
export function isPathActive(pathname: string, pathMatches: string[]): boolean {
  return pathMatches.some(match => 
    pathname === match || pathname.startsWith(`${match}/`)
  );
}

/** Read cached artist id for instant nav before Firestore user doc loads. */
export function getCachedArtistId(currentUid?: string | null): string | undefined {
  try {
    const cached = localStorage.getItem('cachedUserProfile');
    if (!cached) return undefined;
    const profile = JSON.parse(cached) as { artistId?: string | null; uid?: string };
    if (currentUid && (!profile.uid || profile.uid !== currentUid)) {
      return undefined;
    }
    const id = profile?.artistId;
    return typeof id === 'string' && id.length > 0 ? id : undefined;
  } catch {
    return undefined;
  }
}

/** Resolve artist id for profile nav — never return the literal string "undefined". */
export function resolveArtistIdForNav(artistId?: string | null): string | undefined {
  const resolved = artistId ?? getCachedArtistId();
  if (!resolved || resolved === 'undefined') {
    return undefined;
  }
  return resolved;
}

// Helper to get the actual path (handles dynamic paths)
export function getNavPath(item: NavItem, artistId?: string | null): string {
  if (typeof item.path === 'function') {
    const resolved = resolveArtistIdForNav(artistId);
    if (!resolved) {
      console.warn(`[getNavPath] Missing artistId for nav item "${item.id}"`);
      return '';
    }
    return item.path(resolved);
  }
  return item.path;
}


